import OfferInclusionItem from 'components/Common/Inclusions/OfferInclusionItem'
import Group from 'components/utils/Group'
import { take } from 'lib/array/arrayUtils'
import { useMemo } from 'react'
import getPropertyIcon from 'lib/offer/getPropertyIcon'
import type { SearchTileRowInclusion } from 'components/SearchKit/SearchTiles/shared/SearchTileRowInclusionItem'

interface Props {
  facilities: Array<SearchTileRowInclusion>
  size?: 'small' | 'medium'
}

function OfferCardFacilities({ facilities, size = 'medium' }: Props) {
  const inclusions = useMemo(() => take(facilities, 3).map(facility => (
    facility.Icon || !facility.propertyIconName
      ? facility
      : { ...facility, Icon: getPropertyIcon(facility.propertyIconName) }
  )), [facilities])
  if (!inclusions.length) return null

  return <Group direction="vertical" gap={size === 'small' ? 4 : 8}>
    {inclusions.map(facility => <OfferInclusionItem
      key={facility.id}
      inclusion={facility}
      size={size}
      lineClamp={size === 'small' ? 1 : undefined}
      isHighlighted={false}
    />)}
  </Group>
}

export default OfferCardFacilities
